'use strict';
// write your code here
var countries = document.querySelectorAll('.list__item .population');
var total = document.querySelector('.total-population');
var average = document.querySelector('.average-population');
var res = 0;
countries.forEach(function(country) {
    var cleanValue = country.innerText.replaceAll(',', '');
    var parsedValue = parseInt(cleanValue);
    if (!isNaN(parsedValue)) res += parsedValue;
});
function numberFormatter(number) {
    return number.toLocaleString();
}
total.innerText = numberFormatter(res);
average.innerText = numberFormatter(Math.floor(res / countries.length));

//# sourceMappingURL=js_get_data_DOM.a365d15a.js.map
